(function () {
  'use strict';

  var T = window.theme || {};
  var ROUTES = T.routes || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function formatMoney(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    var format = T.moneyFormat || '${{amount}}';
    var amount = (n / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(n / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function itemPriceCents(item) {
    if (!item) return null;
    // Cart-add response can be the line item directly, or { items: [...] } when items[] form is posted.
    if (item.items && item.items.length) item = item.items[0];
    var fields = ['final_price', 'final_line_price', 'discounted_price', 'price', 'line_price', 'original_price'];
    for (var i = 0; i < fields.length; i++) {
      var v = item[fields[i]];
      if (typeof v === 'number' && isFinite(v)) return v;
      if (typeof v === 'string' && v !== '' && isFinite(Number(v))) return Number(v);
    }
    return null;
  }

  function cartAddUrl() {
    var u = ROUTES.cartAdd || '/cart/add';
    return /\.js(\?|$)/.test(u) ? u : u + '.js';
  }

  function showToast(msg) {
    var existing = $('.toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.className = 'toast';
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.remove(); }, 600);
    }, 2400);
  }

  // ==========================================================================
  // Reveal on scroll
  // ==========================================================================
  function initReveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });

    // Safety net: if for any reason an element above the fold never fires the
    // observer (e.g. browser quirks after a locale switch / soft navigation),
    // force every reveal element visible after 1.5s so the page never sits
    // blank on the user.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('visible'); });
    }, 1500);
  }

  // ==========================================================================
  // Cart: AJAX add, drawer, notification, free-shipping bar
  // ==========================================================================
  function updateCartState(cart) {
    if (!cart) return;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    updateShippingBar(cart);
  }

  function updateShippingBar(cart) {
    var bar = $('[data-shipping-bar]');
    if (!bar) return;
    var threshold = T.freeShippingThreshold || 0;
    if (threshold <= 0) { bar.style.display = 'none'; return; }
    var subtotal = cart.total_price;
    var remaining = Math.max(0, threshold - subtotal);
    var pct = Math.min(100, (subtotal / threshold) * 100);
    var msg = $('[data-shipping-message]');
    if (msg) {
      if (remaining > 0) {
        msg.textContent = (T.freeShippingProgress || 'Add {amount} more for free shipping').replace('{amount}', formatMoney(remaining));
      } else {
        msg.textContent = T.freeShippingDone || 'You qualify for free shipping!';
      }
    }
    var prog = $('[data-shipping-progress]');
    if (prog) prog.style.width = pct + '%';
  }

  function refreshCartDrawer() {
    return fetch(ROUTES.root + '?section_id=cart-drawer-fragment', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .catch(function () { return null; });
  }

  function reloadDrawerHTML() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?cache_bust=' + Date.now(), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer) {
          drawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    var overlay = $('[data-cart-drawer-overlay]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    var overlay = $('[data-cart-drawer-overlay]');
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function showCartNotification(item) {
    var n = $('[data-cart-notification]');
    if (!n) return;
    var holder = $('[data-notification-product]');
    if (holder && item) {
      var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
      var priceCents = itemPriceCents(item);
      var priceHtml = priceCents == null ? '' : formatMoney(priceCents);
      var title = item.product_title || item.title || '';
      holder.innerHTML = img + '<div><p style="font-family:Cormorant Garamond,serif;color:var(--brown-deep);font-size:16px;line-height:1.2;margin:0 0 4px;">' + title + '</p><p style="font-size:12px;color:var(--blush);margin:0;">' + priceHtml + '</p></div>';
    }
    n.classList.add('is-open');
    clearTimeout(n._timer);
    n._timer = setTimeout(function () { n.classList.remove('is-open'); }, 4000);
  }

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('.product-add-form, [data-product-form], .pp-form, [data-qa-form]')) return;
      e.preventDefault();
      var formData = new FormData(form);
      var qtyExt = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
      if (qtyExt && !formData.has('quantity')) formData.append('quantity', qtyExt.value || '1');

      var addBtn = form.querySelector('[data-add-button]');
      var addLabel = addBtn ? addBtn.querySelector('[data-add-text]') : null;
      var origText = addLabel ? addLabel.textContent : (addBtn ? addBtn.textContent : '');
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding…';

      fetchJSON(cartAddUrl(), { method: 'POST', body: formData })
        .then(function (item) {
          if (item && item.items && item.items.length === 1) item = item.items[0];
          return fetchJSON(ROUTES.cart).then(function (cart) {
            updateCartState(cart);
            document.dispatchEvent(new CustomEvent('cart:added', { detail: { item: item, cart: cart, form: form } }));
            // Prefer the drawer if it exists in DOM, regardless of setting
            var drawer = $('[data-cart-drawer]');
            if (drawer) {
              reloadDrawerHTML().then(openCartDrawer);
            } else if ($('[data-cart-notification]')) {
              showCartNotification(item);
            } else {
              showToast('Added to cart');
            }
            return cart;
          });
        })
        .catch(function (err) {
          console.error(err);
          showToast('Could not add to cart');
        })
        .finally(function () {
          if (addBtn) addBtn.disabled = false;
          if (addLabel) addLabel.textContent = origText;
        });
    });

    $$('[data-cart-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        // Only intercept if a drawer is rendered on the page
        var drawer = $('[data-cart-drawer]');
        if (!drawer) return; // fall through → navigate to /cart
        if (T.cartType && T.cartType !== 'drawer') return;
        e.preventDefault();
        openCartDrawer();
      });
    });

    $$('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
    var overlay = $('[data-cart-drawer-overlay]');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    document.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-qty-increase]');
      var dec = e.target.closest('[data-qty-decrease]');
      var rm = e.target.closest('[data-line-remove]');
      if (inc || dec) {
        var input = e.target.closest('.cart-item-qty').querySelector('input');
        var newQty = parseInt(input.value, 10) + (inc ? 1 : -1);
        if (newQty < 0) newQty = 0;
        input.value = newQty;
        changeCart(input.dataset.lineKey, newQty);
      } else if (rm) {
        changeCart(rm.dataset.lineKey, 0);
      }
    });

    document.addEventListener('change', function (e) {
      var qtyInput = e.target.closest('.cart-item-qty input');
      if (qtyInput) {
        changeCart(qtyInput.dataset.lineKey, parseInt(qtyInput.value, 10) || 0);
      }
    });

    var note = $('[data-cart-note]');
    if (note) {
      var noteTimer;
      note.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch(ROUTES.cartUpdate, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: note.value })
          });
        }, 600);
      });
    }
  }

  function changeCart(lineKey, qty) {
    return fetchJSON(ROUTES.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    }).then(function (cart) {
      updateCartState(cart);
      reloadDrawerHTML();
    });
  }

  // ==========================================================================
  // Predictive search
  // ==========================================================================
  function initPredictiveSearch() {
    var dialog = $('[data-predictive-search]');
    if (!dialog) return;
    var overlay = $('[data-search-overlay]');
    var input = $('[data-search-input]', dialog);
    var results = $('[data-search-results]', dialog);

    function open() {
      dialog.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input && input.focus(); }, 200);
    }
    function close() {
      dialog.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    $$('[data-search-open]').forEach(function (btn) { btn.addEventListener('click', open); });
    $$('[data-search-close]', dialog).forEach(function (btn) { btn.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dialog.classList.contains('is-open')) close();
    });

    if (!input) return;

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        var popular = $('[data-popular-section]');
        if (popular) results.innerHTML = popular.outerHTML;
        return;
      }
      timer = setTimeout(function () { runSearch(q); }, 220);
    });

    function runSearch(q) {
      var resources = ['product'];
      if (T.searchShowCollections) resources.push('collection');
      if (T.searchShowArticles) resources.push('article');
      if (T.searchShowPages) resources.push('page');
      var url = ROUTES.predictiveSearch
        + '?q=' + encodeURIComponent(q)
        + '&resources[type]=' + resources.join(',')
        + '&resources[limit]=' + (T.searchLimit || 6)
        + '&section_id=predictive-search';
      fetchJSON(url + '&_=json').then(function (data) {
        renderResults(data.resources && data.resources.results, q);
      }).catch(function () {
        results.innerHTML = '<p class="predictive-search-empty">Search unavailable.</p>';
      });
    }

    function renderResults(r, q) {
      if (!r) {
        results.innerHTML = '<p class="predictive-search-empty">No results for "' + q + '".</p>';
        return;
      }
      var html = '';
      if (r.products && r.products.length) {
        html += '<div class="predictive-search-section"><h3 class="predictive-search-heading">Products</h3><ul class="predictive-search-list">';
        r.products.forEach(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image.url + '" alt="">' : '';
          html += '<li class="predictive-search-item"><a href="' + p.url + '">' + img + '<span><span class="predictive-search-item-title">' + p.title + '</span><span class="predictive-search-item-price">' + (p.price ? formatMoney(parseFloat(p.price) * 100) : '') + '</span></span></a></li>';
        });
        html += '</ul></div>';
      }
      if (r.collections && r.collections.length) {
        html += '<div class="predictive-search-section"><h3 class="predictive-search-heading">Collections</h3><ul class="predictive-search-list">';
        r.collections.forEach(function (c) {
          html += '<li class="predictive-search-item"><a href="' + c.url + '"><span class="predictive-search-item-title">' + c.title + '</span></a></li>';
        });
        html += '</ul></div>';
      }
      if (r.articles && r.articles.length) {
        html += '<div class="predictive-search-section"><h3 class="predictive-search-heading">Articles</h3><ul class="predictive-search-list">';
        r.articles.forEach(function (a) {
          html += '<li class="predictive-search-item"><a href="' + a.url + '"><span class="predictive-search-item-title">' + a.title + '</span></a></li>';
        });
        html += '</ul></div>';
      }
      if (r.pages && r.pages.length) {
        html += '<div class="predictive-search-section"><h3 class="predictive-search-heading">Pages</h3><ul class="predictive-search-list">';
        r.pages.forEach(function (p) {
          html += '<li class="predictive-search-item"><a href="' + p.url + '"><span class="predictive-search-item-title">' + p.title + '</span></a></li>';
        });
        html += '</ul></div>';
      }
      if (!html) html = '<p class="predictive-search-empty">No results for "' + q + '".</p>';
      results.innerHTML = html;
    }
  }

  // ==========================================================================
  // Mobile menu drawer
  // ==========================================================================
  function initDrawer() {
    var drawer = $('[data-menu-drawer]');
    var overlay = $('[data-drawer-overlay]');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    $$('[data-menu-open]').forEach(function (btn) { btn.addEventListener('click', open); });
    $$('[data-menu-close]').forEach(function (btn) { btn.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  // ==========================================================================
  // Slideshow (slide + fade, autoplay, swipe, RTL, pause-on-hover)
  // ==========================================================================
  function initSlideshow() {
    $$('[data-slideshow]').forEach(function (root) {
      var track = $('[data-slideshow-track]', root);
      if (!track) return;
      var slides = $$('[data-slide-index]', root);
      if (slides.length < 2) return;
      var index = 0;
      var auto = root.dataset.autoplay === 'true';
      var pauseOnHover = root.dataset.pauseOnHover !== 'false';
      var interval = parseInt(root.dataset.interval || '6', 10) * 1000;
      var transition = root.dataset.transition || 'slide';
      var mobileLayout = root.dataset.mobileLayout || 'overlay';
      var timer = null;
      var dots = $$('[data-slide-dot]', root);
      var isRtl = document.documentElement.dir === 'rtl';

      function go(i) {
        index = (i + slides.length) % slides.length;
        if (transition === 'fade') {
          slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === index); });
        } else {
          // Stack mobile uses native scroll feel; on desktop translate the track
          if (window.matchMedia('(max-width: 768px)').matches && mobileLayout === 'stack') {
            slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === index); });
            slides[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            var off = isRtl ? index * 100 : -index * 100;
            track.style.transform = 'translateX(' + off + '%)';
          }
        }
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === index); });
      }
      function next() { go(index + 1); }
      function prev() { go(index - 1); }
      function start() { stop(); if (auto) timer = setInterval(next, interval); }
      function stop() { if (timer) clearInterval(timer); }

      var nb = $('[data-slide-next]', root);
      var pb = $('[data-slide-prev]', root);
      if (nb) nb.addEventListener('click', function () { next(); start(); });
      if (pb) pb.addEventListener('click', function () { prev(); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.dataset.slideDot, 10)); start(); });
      });
      if (pauseOnHover) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
      }

      var startX = 0;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) { isRtl ? prev() : next(); } else { isRtl ? next() : prev(); }
        start();
      });
      start();
    });
  }

  // ==========================================================================
  // Announcement rotator
  // ==========================================================================
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (root) {
      var slides = $$('.announcement-slide', root);
      if (slides.length < 2) return;
      var current = 0;
      var auto = root.dataset.autoRotate === 'true';
      var speed = parseInt(root.dataset.rotateSpeed || '5', 10) * 1000;
      var timer = null;
      function show(i) {
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        current = i;
      }
      function next() { show((current + 1) % slides.length); }
      function prev() { show((current - 1 + slides.length) % slides.length); }
      function start() { if (timer) clearInterval(timer); if (auto) timer = setInterval(next, speed); }
      function stop() { if (timer) clearInterval(timer); }
      var pb = $('[data-ann-prev]', root); var nb = $('[data-ann-next]', root);
      if (pb) pb.addEventListener('click', function () { prev(); start(); });
      if (nb) nb.addEventListener('click', function () { next(); start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    });
  }

  // ==========================================================================
  // Wishlist (localStorage)
  // ==========================================================================
  function initWishlist() {
    var KEY = 'estora_wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
      catch (e) { return []; }
    }
    function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
    function refresh() {
      var liked = read();
      $$('[data-like-id]').forEach(function (btn) {
        if (liked.indexOf(btn.dataset.likeId) !== -1) btn.classList.add('is-liked');
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-like-id]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.dataset.likeId;
      var liked = read();
      var i = liked.indexOf(id);
      if (i === -1) { liked.push(id); btn.classList.add('is-liked'); }
      else { liked.splice(i, 1); btn.classList.remove('is-liked'); }
      write(liked);
    });
    refresh();
  }

  // ==========================================================================
  // Header sticky / hide-on-scroll / shadow / transparent
  // ==========================================================================
  function initHeaderScroll() {
    var nav = $('nav');
    if (!nav) return;
    var isTransparent = nav.classList.contains('is-transparent');
    document.body.dataset.headerShadow = T.headerShadowOnScroll;
    document.body.dataset.headerHide = T.headerHideOnScroll;

    var navHeight = nav.offsetHeight || 72;
    document.documentElement.style.setProperty('--header-height', navHeight + 'px');

    if (!T.headerSticky && !isTransparent) return;

    var lastY = 0;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      if (y > 4) nav.classList.add('is-scrolled'); else nav.classList.remove('is-scrolled');
      if (T.headerHideOnScroll && y > 240) {
        if (y > lastY) nav.classList.add('is-hidden'); else nav.classList.remove('is-hidden');
      } else {
        nav.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ==========================================================================
  // Sticky add-to-cart — appears when the main Buy button scrolls off-screen
  // ==========================================================================
  function initStickyATC() {
    var bar = $('[data-sticky-atc]');
    if (!bar || !T.stickyAtcEnabled) return;
    var trigger = $('.pp-buy-buttons') || $('[data-add-button]') || $('.product-page-info');
    if (!trigger) return;
    function update() {
      var rect = trigger.getBoundingClientRect();
      var off = rect.bottom < 0 || rect.top > window.innerHeight;
      bar.classList.toggle('is-visible', off);
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // ==========================================================================
  // Related products
  // ==========================================================================
  function initRelatedProducts() {
    $$('[data-related-products]').forEach(function (section) {
      var grid = $('[data-related-grid]', section);
      if (!grid || grid.children.length > 0) return;
      var pid = section.dataset.productId;
      var sid = section.dataset.sectionId;
      var limit = section.dataset.limit || 4;
      if (!pid) return;
      fetch('/recommendations/products?section_id=' + sid + '&product_id=' + pid + '&limit=' + limit)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-related-grid]');
          if (newGrid && newGrid.innerHTML.trim()) grid.innerHTML = newGrid.innerHTML;
          else section.style.display = 'none';
        })
        .catch(function () { section.style.display = 'none'; });
    });
  }

  // ==========================================================================
  // Collection filter drawer (mobile) + horizontal-toolbar dropdown UX
  // ==========================================================================
  function initCollectionFilters() {
    var toggle = $('[data-filter-toggle]');
    var close = $('[data-filter-close]');
    var filters = $('[data-collection-filters]');
    if (toggle && filters) {
      toggle.addEventListener('click', function () {
        filters.classList.toggle('is-open');
        filters.style.display = filters.classList.contains('is-open') ? 'block' : '';
        if (close) close.style.display = filters.classList.contains('is-open') ? 'block' : 'none';
      });
      if (close) {
        close.addEventListener('click', function () {
          filters.classList.remove('is-open');
          if (window.innerWidth <= 1024) filters.style.display = 'none';
        });
      }
    }

    // Horizontal toolbar: only one filter dropdown open at a time
    var toolbarFilters = $$('[data-toolbar-filter]');
    toolbarFilters.forEach(function (f) {
      f.addEventListener('toggle', function () {
        if (f.open) {
          toolbarFilters.forEach(function (other) { if (other !== f) other.removeAttribute('open'); });
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!toolbarFilters.length) return;
      if (!e.target.closest('[data-toolbar-filter]')) {
        toolbarFilters.forEach(function (f) { f.removeAttribute('open'); });
      }
    });
  }

  // ==========================================================================
  // Video lazy-play (poster click)
  // ==========================================================================
  function initVideo() {
    $$('[data-video-poster]').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var wrap = poster.closest('[data-video-wrap]');
        var url = wrap.dataset.videoUrl;
        var provider = wrap.dataset.videoProvider;
        var loop = wrap.dataset.videoLoop === 'true';
        var src = '';
        if (provider === 'youtube') {
          var vid = url.split('v=')[1] ? url.split('v=')[1].split('&')[0] : url.split('/').pop();
          src = 'https://www.youtube.com/embed/' + vid + '?autoplay=1&rel=0' + (loop ? '&loop=1&playlist=' + vid : '');
        } else if (provider === 'vimeo') {
          var vidv = url.split('/').pop();
          src = 'https://player.vimeo.com/video/' + vidv + '?autoplay=1' + (loop ? '&loop=1' : '');
        } else { return; }
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.width = '100%'; iframe.style.height = '100%'; iframe.style.border = '0';
        wrap.replaceChild(iframe, poster);
      });
    });
  }

  // ==========================================================================
  // Variant picker (main product) — keep variant id, price, and qty totals in sync
  // ==========================================================================
  function initVariantPickers() {
    $$('form[id^="MainProductForm-"]').forEach(function (form) {
      var idInput = form.querySelector('[data-variant-id]') || form.querySelector('input[name="id"]');
      var inputs = form.querySelectorAll('[data-option-input]');

      var productJsonScript = document.querySelector('[data-product-json]');
      var product = productJsonScript ? JSON.parse(productJsonScript.textContent) : null;
      if (!product || !idInput) return;

      var section = form.closest('section') || form.parentElement;
      // Quantity input is inside the form (or, for legacy markup, outside via form="..." attribute)
      var qtyInput = form.querySelector('input[name="quantity"]')
        || document.querySelector('input[name="quantity"][form="' + form.id + '"]');

      function getChosen() {
        var byOption = {};
        inputs.forEach(function (el) {
          if (el.tagName === 'SELECT') {
            byOption[el.name] = el.value;
          } else if (el.type === 'radio' && el.checked) {
            byOption[el.name] = el.value;
          }
        });
        return Object.keys(byOption).map(function (k) { return byOption[k]; });
      }

      function getMatch() {
        if (inputs.length === 0) return product.variants[0];
        var chosen = getChosen();
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });
      }

      function getQty() {
        if (!qtyInput) return 1;
        var v = parseInt(qtyInput.value, 10);
        return v > 0 ? v : 1;
      }

      function update() {
        var match = getMatch();
        if (!match) return;
        idInput.value = match.id;
        var qty = getQty();
        var totalCents = match.price * qty;
        var compareTotalCents = (match.compare_at_price || 0) * qty;

        // Price (now reflects qty × unit price)
        var priceEl = section.querySelector('[data-price-current]');
        if (priceEl) priceEl.textContent = formatMoney(totalCents);
        var compareEl = section.querySelector('[data-price-compare]');
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(compareTotalCents);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        // Unit price hint (small label under main price)
        var unitEl = section.querySelector('[data-price-unit]');
        if (unitEl) {
          if (qty > 1) {
            unitEl.textContent = qty + ' × ' + formatMoney(match.price);
            unitEl.style.display = '';
          } else {
            unitEl.style.display = 'none';
          }
        }

        // Sticky add-to-cart bar
        var stickyPrice = $('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = formatMoney(totalCents);

        // Selected option label
        if (product.options) {
          product.options.forEach(function (optName, i) {
            var badge = section.querySelector('[data-selected-' + optName.toLowerCase().replace(/\s+/g, '-') + ']');
            if (badge) badge.textContent = (getChosen()[i] || '');
          });
        }

        // Add to Cart button availability
        $$('[data-add-button]', section).forEach(function (b) {
          b.disabled = !match.available;

          var label = b.querySelector('[data-add-text]');
          if (label) {
            label.textContent = match.available
              ? label.dataset.addLabel
              : label.dataset.soldOutLabel;
          }
        });

        $$('[data-buy-now]', section).forEach(function (b) {
          b.disabled = !match.available;

          var label = b.querySelector('[data-buy-now-text]');
          if (label) {
            label.textContent = match.available
              ? label.dataset.buyLabel
              : label.dataset.soldOutLabel;
          }
        });

        // URL variant param
        if (history.replaceState && match.id) {
          var url = new URL(window.location);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url);
        }
      }

      inputs.forEach(function (el) { el.addEventListener('change', update); });
      if (qtyInput) {
        qtyInput.addEventListener('input', update);
        qtyInput.addEventListener('change', update);
      }
      update();
    });
  }

  // ==========================================================================
  // Product gallery — thumbnail click swaps main image
  // ==========================================================================
  function initProductGallery() {
    $$('[data-product-media]').forEach(function (root) {
      var thumbs = $$('[data-thumb-index]', root);
      var mains = $$('[data-main-index]', root);
      if (thumbs.length < 2) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.dataset.thumbIndex;
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumbIndex === idx); });
          mains.forEach(function (m) { m.classList.toggle('is-active', m.dataset.mainIndex === idx); });
        });
      });
    });
  }

  // ==========================================================================
  // Newsletter popup — delay / scroll / exit-intent / immediate, with cookie
  // ==========================================================================
  function initNewsletterPopup() {
    var root = $('[data-newsletter-popup]');
    if (!root) return;

    var trigger = root.dataset.trigger || 'delay';
    var delay = (parseInt(root.dataset.delay, 10) || 0) * 1000;
    var scrollPct = parseInt(root.dataset.scrollPct, 10) || 40;
    var cookieDays = parseInt(root.dataset.cookieDays, 10) || 7;
    var showMobile = root.dataset.showMobile !== 'false';
    var showDesktop = root.dataset.showDesktop !== 'false';

    var COOKIE = 'estora_newsletter_popup';

    function getCookie() {
      try { return document.cookie.split('; ').find(function (c) { return c.indexOf(COOKIE + '=') === 0; }); }
      catch (e) { return null; }
    }
    function setCookie() {
      try {
        var d = new Date();
        d.setTime(d.getTime() + cookieDays * 24 * 60 * 60 * 1000);
        document.cookie = COOKIE + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
      } catch (e) {}
    }

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile && !showMobile) return;
    if (!isMobile && !showDesktop) return;
    if (cookieDays > 0 && getCookie()) return;
    if (window.location.search.indexOf('preview_theme_id') !== -1 && Shopify && Shopify.designMode) {
      // Don't auto-open in theme editor — only on the actual storefront
      return;
    }

    function open() {
      if (root.classList.contains('is-open')) return;
      root.removeAttribute('hidden');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      root.classList.remove('is-open');
      setTimeout(function () { root.setAttribute('hidden', ''); }, 400);
      document.body.style.overflow = '';
      if (cookieDays > 0) setCookie();
    }

    $$('[data-newsletter-close]', root).forEach(function (b) { b.addEventListener('click', close); });
    var overlay = $('[data-newsletter-overlay]', root);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // If form posts successfully (via Liquid render after redirect), keep open briefly so user sees success
    if ($('.newsletter-popup-success', root)) {
      open();
      return;
    }

    var openCalled = false;
    function maybeOpen() { if (openCalled) return; openCalled = true; open(); }

    if (trigger === 'immediate') {
      maybeOpen();
    } else if (trigger === 'delay') {
      setTimeout(maybeOpen, delay);
    } else if (trigger === 'scroll') {
      var onScroll = function () {
        var doc = document.documentElement;
        var max = (doc.scrollHeight - doc.clientHeight) || 1;
        var pct = (window.scrollY / max) * 100;
        if (pct >= scrollPct) {
          maybeOpen();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    } else if (trigger === 'exit') {
      // Desktop only — exit-intent doesn't make sense on touch
      if (!isMobile) {
        var onMouseLeave = function (e) {
          if (e.clientY < 0) {
            maybeOpen();
            document.removeEventListener('mouseleave', onMouseLeave);
          }
        };
        document.addEventListener('mouseleave', onMouseLeave);
      } else {
        // Fall back to a long delay on mobile
        setTimeout(maybeOpen, 30000);
      }
    }
  }

  // ==========================================================================
  // Description "Read more" toggle
  // ==========================================================================
  function initDescriptionCollapse() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-desc-toggle]');
      if (!btn) return;
      e.preventDefault();
      var desc = btn.previousElementSibling;
      while (desc && !desc.matches('[data-pp-desc]')) desc = desc.previousElementSibling;
      if (!desc) return;
      var expanded = desc.classList.toggle('is-expanded');
      btn.textContent = expanded ? (btn.dataset.lessText || 'Read less') : (btn.dataset.moreText || btn.textContent);
    });
  }

  // ==========================================================================
  // Buy Now — AJAX add the current variant + qty, then redirect to /checkout
  // ==========================================================================
  function initBuyNow() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-buy-now]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;

      // Find the form: prefer a sibling product form (same section), then fallback
      var form = btn.closest('form');
      if (!form) {
        var formId = btn.dataset.productForm;
        form = formId ? document.getElementById(formId) : null;
      }
      if (!form) {
        form = document.querySelector('form[action*="/cart/add"]');
      }
      if (!form) return;

      var label = btn.querySelector('[data-buy-now-text]');
      var origText = label ? label.textContent : btn.textContent;
      btn.disabled = true;
      if (label) label.textContent = 'Adding…'; else btn.textContent = 'Adding…';

      var fd = new FormData(form);
      // Make sure the qty is included even when its input lives outside the form
      var qtyExternal = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
      if (qtyExternal && !fd.has('quantity')) fd.append('quantity', qtyExternal.value || '1');

      fetchJSON(cartAddUrl(), { method: 'POST', body: fd })
        .then(function () {
          window.location.href = (ROUTES.root || '/') + 'checkout';
        })
        .catch(function () {
          btn.disabled = false;
          if (label) label.textContent = origText; else btn.textContent = origText;
          showToast('Could not start checkout');
        });
    });
  }

  // ==========================================================================
  // Quantity stepper (works on product page + cart page + cart drawer)
  // ==========================================================================
  function initQuantityStepper() {
    document.addEventListener('click', function (e) {
      var up = e.target.closest('[data-qty-up]');
      var down = e.target.closest('[data-qty-down]');
      if (!up && !down) return;
      var stepper = (up || down).closest('.pp-qty-stepper, .cart-item-qty');
      var input = stepper && stepper.querySelector('input');
      if (!input) return;
      var min = down && stepper.dataset.cartQtyWrap !== undefined ? 0 : 1;
      var v = parseInt(input.value, 10) || min;
      v = up ? v + 1 : Math.max(0, v - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // ==========================================================================
  // Product tabs — switch panels + optional auto-rotate
  // ==========================================================================
  function initProductTabs() {
    $$('[data-product-tabs]').forEach(function (root) {
      var buttons = $$('[data-tab-target]', root);
      var panels = $$('[data-tab-panel]', root);
      if (!buttons.length || !panels.length) return;

      var auto = root.dataset.autoplay === 'true';
      var speed = parseInt(root.dataset.autoplaySpeed || '6', 10) * 1000;
      var current = parseInt(root.dataset.defaultTab || '0', 10);
      var timer = null;

      function activate(idx) {
        idx = ((idx % buttons.length) + buttons.length) % buttons.length;
        current = idx;
        buttons.forEach(function (b, i) {
          var on = i === idx;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, i) {
          var on = i === idx;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
      }

      function start() { stop(); if (auto) timer = setInterval(function () { activate(current + 1); }, speed); }
      function stop() { if (timer) clearInterval(timer); }

      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { activate(i); start(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      activate(current);
      start();
    });
  }

  // ==========================================================================
  // Countdown timer
  // ==========================================================================
  function initCountdown() {
    $$('[data-countdown]').forEach(function (root) {
      var raw = root.dataset.target;
      var tz = root.dataset.tz || '+00:00';
      if (!raw) return;
      var iso;
      if (tz === 'local') {
        iso = raw.replace(' ', 'T');
      } else {
        iso = raw.replace(' ', 'T') + ':00' + tz;
      }
      var target = new Date(iso).getTime();
      if (isNaN(target)) return;

      var dEl = $('[data-unit-days] .countdown-number', root);
      var hEl = $('[data-unit-hours] .countdown-number', root);
      var mEl = $('[data-unit-minutes] .countdown-number', root);
      var sEl = $('[data-unit-seconds] .countdown-number', root);
      var expired = $('[data-countdown-expired]', root);
      var clock = $('.countdown-clock', root);
      var action = root.dataset.expiredAction || 'message';
      var showDays = root.dataset.showDays === 'true';
      var showHours = root.dataset.showHours === 'true';
      var showMinutes = root.dataset.showMinutes === 'true';

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          if (action === 'hide') { root.classList.add('is-expired-hidden'); }
          else if (action === 'message') {
            if (clock) clock.style.display = 'none';
            if (expired) expired.style.display = 'block';
          } else {
            if (dEl) dEl.textContent = '00';
            if (hEl) hEl.textContent = '00';
            if (mEl) mEl.textContent = '00';
            if (sEl) sEl.textContent = '00';
          }
          clearInterval(timer);
          return;
        }
        var totalSec = Math.floor(diff / 1000);
        var days = Math.floor(totalSec / 86400);
        var hours = Math.floor((totalSec % 86400) / 3600);
        var minutes = Math.floor((totalSec % 3600) / 60);
        var seconds = totalSec % 60;
        // If days hidden, roll into hours; etc.
        if (!showDays) hours += days * 24;
        if (!showHours) minutes += hours * 60;
        if (!showMinutes) seconds += minutes * 60;
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(minutes);
        if (sEl) sEl.textContent = pad(seconds);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  // ==========================================================================
  // Testimonials slider — responsive (3 desktop / 2 tablet / 1 mobile)
  // ==========================================================================
  function initTestimonialsSlider() {
    $$('[data-testimonials-slider]').forEach(function (root) {
      var track = $('[data-testimonials-track]', root);
      if (!track) return;
      var slides = track.children;
      if (slides.length < 2) return;
      var dots = $$('[data-testimonials-dot]', root);
      var idx = 0;
      var auto = root.dataset.autoplay === 'true';
      var interval = parseInt(root.dataset.interval || '6', 10) * 1000;
      var timer = null;
      var isRtl = document.documentElement.dir === 'rtl';

      function slidesPerView() {
        if (window.matchMedia('(max-width: 700px)').matches) return 1;
        if (window.matchMedia('(max-width: 1024px)').matches) return 2;
        return 3;
      }

      function maxIndex() { return Math.max(0, slides.length - slidesPerView()); }

      function go(i) {
        var max = maxIndex();
        idx = Math.max(0, Math.min(i, max));
        var spv = slidesPerView();
        var step = 100 / spv;
        var off = isRtl ? idx * step : -idx * step;
        track.style.transform = 'translateX(' + off + '%)';
        dots.forEach(function (d, n) {
          d.style.display = n > max ? 'none' : '';
          d.classList.toggle('is-active', n === idx);
        });
      }

      function next() { go(idx >= maxIndex() ? 0 : idx + 1); }
      function prev() { go(idx <= 0 ? maxIndex() : idx - 1); }
      function start() { stop(); if (auto) timer = setInterval(next, interval); }
      function stop() { if (timer) clearInterval(timer); }

      var nb = $('[data-testimonials-next]', root);
      var pb = $('[data-testimonials-prev]', root);
      if (nb) nb.addEventListener('click', function () { next(); start(); });
      if (pb) pb.addEventListener('click', function () { prev(); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.testimonialsDot, 10)); start(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      var startX = 0;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) { isRtl ? prev() : next(); } else { isRtl ? next() : prev(); }
        start();
      });

      window.addEventListener('resize', function () { go(idx); });
      go(0);
      start();
    });
  }

  // ==========================================================================
  // Cart page — AJAX qty + remove (no full page reload)
  // ==========================================================================
  function initCartPage() {
    var page = $('.cart-page');
    if (!page) return;

    function refresh(cart) {
      // Subtotal
      var subtotal = page.querySelector('.cart-subtotal strong');
      if (subtotal && cart) subtotal.textContent = formatMoney(cart.total_price);
      var counts = $$('[data-cart-count]');
      counts.forEach(function (el) { el.textContent = cart.item_count; });
    }

    function reloadRows() {
      return fetch(window.location.pathname, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelector('.cart-items');
          var current = page.querySelector('.cart-items');
          if (newItems && current) current.innerHTML = newItems.innerHTML;
          var newSummary = doc.querySelector('.cart-summary, .cart-empty-state');
          var oldSummary = page.querySelector('.cart-summary, .cart-empty-state');
          if (newSummary && oldSummary) oldSummary.outerHTML = newSummary.outerHTML;
        });
    }

    var qtyTimers = {};
    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var key = input.dataset.lineKey;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function () {
        fetchJSON(ROUTES.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (cart) {
          refresh(cart);
          if (qty === 0 || cart.item_count === 0) reloadRows();
          else {
            // Update the row's line total
            var row = input.closest('[data-cart-row]');
            var item = cart.items.find(function (i) { return i.key === key; });
            if (row && item) {
              var total = row.querySelector('[data-line-total]');
              if (total) total.textContent = formatMoney(item.final_line_price);
            }
          }
        }).catch(function () {});
      }, 300);
    });

    page.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-line-remove]');
      if (!rm) return;
      e.preventDefault();
      var key = rm.dataset.lineKey;
      var row = rm.closest('[data-cart-row]');
      if (row) row.style.opacity = '0.4';
      fetchJSON(ROUTES.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (cart) {
        refresh(cart);
        reloadRows();
      });
    });

    // Save note on blur
    var note = page.querySelector('#CartNote');
    if (note) {
      note.addEventListener('blur', function () {
        fetch(ROUTES.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      });
    }
  }

  // ==========================================================================
  // Locale / country switcher
  //
  // Shopify's /localization endpoint sets a cookie and then redirects to the
  // `return_to` URL. When the storefront is password-protected and the user
  // is browsing through ?preview_theme_id=…, the redirect frequently lands on
  // /password and strips the preview query param — which is why the page can
  // end up looking blank or like the bare password gate after the language
  // change.
  //
  // To avoid that, we intercept any localization form submit: POST it via
  // fetch (so the cookie still gets set in the response), then explicitly
  // navigate the browser to the current URL with the original search params
  // preserved. The new URL therefore always carries preview_theme_id (when
  // present), the password-bypass cookies stay valid, and the user lands on
  // the theme they were just looking at — just in the new locale.
  // ==========================================================================
  function initLocaleForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/localization') === -1) return;

      e.preventDefault();
      var fd = new FormData(form);
      // Always tell Shopify to return to the *current* full URL so the
      // preview_theme_id (and any other query params) survive.
      var returnUrl = window.location.pathname + window.location.search;
      if (fd.has('return_to')) fd.set('return_to', returnUrl); else fd.append('return_to', returnUrl);

      // Disable the form while we work so the user can't double-submit.
      var ctrls = form.querySelectorAll('input, select, button, textarea');
      ctrls.forEach(function (c) { c.disabled = true; });

      fetch(form.action || '/localization', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin'
        // Use the default redirect-following behavior — some browsers won't
        // honor Set-Cookie on opaque redirect responses, so we deliberately
        // let fetch follow Shopify's 302 just so the locale cookie is set
        // reliably. We discard the response body and navigate ourselves.
      })
        .catch(function () { /* network / opaque errors are non-fatal here */ })
        .finally(function () {
          // Hard-navigate to preserve preview_theme_id and other query params.
          window.location.href = returnUrl;
        });
    }, true); // capture phase so we beat any inline onchange handlers
  }

  // ==========================================================================
  // Product carousel — slide track, prev/next, dots, autoplay, swipe
  // ==========================================================================
  function initProductCarousel() {
    $$('[data-product-carousel]').forEach(function (root) {
      var track = $('[data-carousel-track]', root);
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      var prevBtn = $('[data-carousel-prev]', root);
      var nextBtn = $('[data-carousel-next]', root);
      var dotsHost = $('[data-carousel-dots]', root);

      var perDesktop = parseInt(root.dataset.perViewDesktop || '4', 10);
      var perTablet = parseInt(root.dataset.perViewTablet || '2', 10);
      var perMobile = parseInt(root.dataset.perViewMobile || '1', 10);
      var auto = root.dataset.autoplay === 'true';
      var interval = parseInt(root.dataset.interval || '6', 10) * 1000;
      var isRtl = document.documentElement.dir === 'rtl';
      var idx = 0;
      var timer = null;

      function perView() {
        if (window.matchMedia('(max-width: 700px)').matches) return perMobile;
        if (window.matchMedia('(max-width: 1024px)').matches) return perTablet;
        return perDesktop;
      }
      function maxIndex() { return Math.max(0, slides.length - perView()); }

      function buildDots() {
        if (!dotsHost) return;
        dotsHost.innerHTML = '';
        var pages = maxIndex() + 1;
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-carousel-dot';
          dot.setAttribute('data-carousel-dot', i);
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dotsHost.appendChild(dot);
        }
        $$('[data-carousel-dot]', dotsHost).forEach(function (d) {
          d.addEventListener('click', function () { go(parseInt(d.dataset.carouselDot, 10)); restart(); });
        });
      }

      function go(i) {
        var max = maxIndex();
        idx = Math.max(0, Math.min(i, max));
        var spv = perView();
        var step = 100 / spv;
        var off = isRtl ? idx * step : -idx * step;
        track.style.transform = 'translateX(' + off + '%)';
        $$('[data-carousel-dot]', dotsHost || root).forEach(function (d, n) {
          d.classList.toggle('is-active', n === idx);
        });
        if (prevBtn) prevBtn.disabled = idx <= 0;
        if (nextBtn) nextBtn.disabled = idx >= max;
      }

      function next() { go(idx >= maxIndex() ? 0 : idx + 1); }
      function prev() { go(idx <= 0 ? maxIndex() : idx - 1); }
      function start() { stop(); if (auto) timer = setInterval(next, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { start(); }

      slides.forEach(function (s) {
        s.style.flex = '0 0 calc(100% / var(--carousel-per-view))';
      });

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      var startX = 0;
      track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) { isRtl ? prev() : next(); } else { isRtl ? next() : prev(); }
        restart();
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { buildDots(); go(Math.min(idx, maxIndex())); }, 120);
      });

      buildDots();
      go(0);
      start();
    });
  }

  // ==========================================================================
  // Quick-add popup — fetch product, render variant picker + add to cart
  // ==========================================================================
  var quickAddCache = {};

  function initQuickAddPopup() {
    var popup = $('[data-quick-add-popup]');
    var overlay = $('[data-quick-add-overlay]');
    var body = $('[data-quick-add-body]');
    if (!popup || !overlay || !body) return;

    var lastTrigger = null;

    function open() {
      popup.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
    }

    function close() {
      popup.classList.remove('is-open');
      overlay.classList.remove('is-open');
      setTimeout(function () {
        popup.hidden = true;
        overlay.hidden = true;
        body.innerHTML = '<div class="quick-add-popup-loading" data-quick-add-loading><span class="quick-add-spinner"></span></div>';
      }, 300);
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function findMatchingVariant(product, chosen) {
      if (!product.variants.length) return null;
      if (!product.options || !product.options.length) return product.variants[0];
      return product.variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      }) || null;
    }

    function getChosenOptions(form) {
      var inputs = form.querySelectorAll('[data-qa-option]');
      var byOption = {};
      inputs.forEach(function (el) {
        var optIdx = parseInt(el.dataset.optionIndex, 10);
        if (el.tagName === 'SELECT') {
          byOption[optIdx] = el.value;
        } else if (el.type === 'radio' && el.checked) {
          byOption[optIdx] = el.value;
        }
      });
      return Object.keys(byOption).sort(function (a, b) { return a - b; }).map(function (k) { return byOption[k]; });
    }

    function renderProduct(product, opts) {
      opts = opts || {};
      var styleOverride = opts.variantStyle || 'auto';
      var image = product.featured_image || (product.images && product.images[0]) || '';
      var imgSrc = image ? (image.indexOf('//') === 0 ? 'https:' + image : image) : '';
      var hasOptions = product.options && product.options.length && !(product.options.length === 1 && product.options[0] === 'Title');
      var variant = product.variants[0];
      // Prefer first available variant if any
      var firstAvailable = product.variants.find(function (v) { return v.available; });
      if (firstAvailable) variant = firstAvailable;

      var optionsHtml = '';
      if (hasOptions) {
        product.options.forEach(function (optName, optIdx) {
          var values = [];
          product.variants.forEach(function (v) {
            var val = v.options[optIdx];
            if (val && values.indexOf(val) === -1) values.push(val);
          });
          var lower = optName.toLowerCase();
          var isColor = lower.indexOf('color') !== -1 || lower.indexOf('colour') !== -1;
          var style;
          if (styleOverride === 'color_swatch') style = 'color';
          else if (styleOverride === 'buttons') style = 'buttons';
          else if (styleOverride === 'dropdown') style = 'select';
          else style = isColor ? 'color' : (values.length > 4 ? 'select' : 'buttons');

          optionsHtml += '<fieldset class="qa-option qa-option-' + style + '">' +
            '<legend class="qa-option-label"><span>' + escapeHtml(optName) + '</span> <span class="qa-option-value" data-qa-option-value="' + optIdx + '">' + escapeHtml(variant.options[optIdx] || '') + '</span></legend>';

          if (style === 'select') {
            optionsHtml += '<select class="qa-option-select" data-qa-option data-option-index="' + optIdx + '" name="options[' + escapeHtml(optName) + ']">';
            values.forEach(function (val) {
              optionsHtml += '<option value="' + escapeHtml(val) + '"' + (val === variant.options[optIdx] ? ' selected' : '') + '>' + escapeHtml(val) + '</option>';
            });
            optionsHtml += '</select>';
          } else if (style === 'color') {
            optionsHtml += '<div class="qa-swatches">';
            values.forEach(function (val) {
              var checked = val === variant.options[optIdx] ? ' checked' : '';
              optionsHtml += '<label class="qa-swatch" title="' + escapeHtml(val) + '">' +
                '<input type="radio" name="qa-opt-' + optIdx + '" value="' + escapeHtml(val) + '" data-qa-option data-option-index="' + optIdx + '"' + checked + '>' +
                '<span class="qa-swatch-dot" style="background:' + escapeHtml(val.toLowerCase().replace(/\s+/g, '')) + ';"></span>' +
                '<span class="qa-swatch-label">' + escapeHtml(val) + '</span>' +
                '</label>';
            });
            optionsHtml += '</div>';
          } else {
            optionsHtml += '<div class="qa-buttons">';
            values.forEach(function (val) {
              var checked = val === variant.options[optIdx] ? ' checked' : '';
              optionsHtml += '<label class="qa-button-pill">' +
                '<input type="radio" name="qa-opt-' + optIdx + '" value="' + escapeHtml(val) + '" data-qa-option data-option-index="' + optIdx + '"' + checked + '>' +
                '<span>' + escapeHtml(val) + '</span>' +
                '</label>';
            });
            optionsHtml += '</div>';
          }
          optionsHtml += '</fieldset>';
        });
      }

      var priceHtml = '<span class="qa-price-current" data-qa-price>' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml += ' <span class="qa-price-compare" data-qa-compare>' + formatMoney(variant.compare_at_price) + '</span>';
      } else {
        priceHtml += ' <span class="qa-price-compare" data-qa-compare style="display:none"></span>';
      }

      var html = '<div class="quick-add-popup-grid">' +
        '<div class="quick-add-popup-media">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" data-qa-image>' : '<div class="quick-add-popup-media-placeholder"></div>') +
        '</div>' +
        '<div class="quick-add-popup-content">' +
          (product.vendor ? '<p class="qa-vendor">' + escapeHtml(product.vendor) + '</p>' : '') +
          '<h2 id="QuickAddTitle" class="qa-title">' + escapeHtml(product.title) + '</h2>' +
          '<p class="qa-price">' + priceHtml + '</p>' +
          (product.description ? '<div class="qa-desc">' + product.description + '</div>' : '') +
          '<form class="qa-form" data-qa-form action="' + (ROUTES.cartAdd || '/cart/add') + '" method="post">' +
            '<input type="hidden" name="form_type" value="product">' +
            '<input type="hidden" name="id" value="' + variant.id + '" data-qa-variant-id>' +
            optionsHtml +
            '<div class="qa-availability" data-qa-availability></div>' +
            '<div class="qa-actions">' +
              '<div class="qa-qty">' +
                '<button type="button" data-qa-qty-down aria-label="Decrease quantity">−</button>' +
                '<input type="number" name="quantity" value="1" min="1" inputmode="numeric" data-qa-qty>' +
                '<button type="button" data-qa-qty-up aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="submit" class="btn-primary qa-add" data-qa-add>' +
                '<span data-qa-add-text>Add to cart</span>' +
              '</button>' +
            '</div>' +
            '<a href="' + escapeHtml(product.url) + '" class="qa-view-full">View full details</a>' +
          '</form>' +
        '</div>' +
      '</div>';

      body.innerHTML = html;
      wireForm(product);
    }

    function wireForm(product) {
      var form = $('[data-qa-form]', body);
      if (!form) return;
      var idInput = $('[data-qa-variant-id]', form);
      var priceEl = $('[data-qa-price]', body);
      var compareEl = $('[data-qa-compare]', body);
      var imgEl = $('[data-qa-image]', body);
      var addBtn = $('[data-qa-add]', form);
      var addTxt = $('[data-qa-add-text]', form);
      var availEl = $('[data-qa-availability]', form);

      function update() {
        var chosen = getChosenOptions(form);
        var match = findMatchingVariant(product, chosen);
        if (!match) {
          addBtn.disabled = true;
          if (addTxt) addTxt.textContent = 'Unavailable';
          if (availEl) availEl.textContent = 'This combination is unavailable.';
          return;
        }
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (imgEl && match.featured_image && match.featured_image.src) {
          var src = match.featured_image.src;
          imgEl.src = src.indexOf('//') === 0 ? 'https:' + src : src;
        }
        addBtn.disabled = !match.available;
        if (addTxt) addTxt.textContent = match.available ? 'Add to cart' : 'Sold out';
        if (availEl) availEl.textContent = match.available ? '' : 'Sold out';

        // Update selected-value labels
        product.options.forEach(function (_, i) {
          var lbl = body.querySelector('[data-qa-option-value="' + i + '"]');
          if (lbl) lbl.textContent = chosen[i] || '';
        });
      }

      $$('[data-qa-option]', form).forEach(function (el) {
        el.addEventListener('change', update);
      });

      $('[data-qa-qty-up]', form).addEventListener('click', function () {
        var inp = $('[data-qa-qty]', form);
        inp.value = (parseInt(inp.value, 10) || 1) + 1;
      });
      $('[data-qa-qty-down]', form).addEventListener('click', function () {
        var inp = $('[data-qa-qty]', form);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1);
      });
    }

    function loadProduct(handle, productUrl, opts) {
      var key = handle || productUrl;
      if (quickAddCache[key]) {
        renderProduct(quickAddCache[key], opts);
        return;
      }

      var candidates = [];
      if (productUrl) {
        var path = productUrl.split('?')[0].split('#')[0].replace(/\/$/, '');
        candidates.push(path + '.js');
      }
      if (handle) {
        candidates.push((ROUTES.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js');
      }

      function tryNext(i, lastErr) {
        if (i >= candidates.length) {
          console.warn('[quick-add] all candidate URLs failed', candidates, lastErr);
          body.innerHTML = '<div class="quick-add-popup-error"><p>Could not load product. <a href="' + escapeHtml(productUrl || '#') + '">View full details</a></p></div>';
          return;
        }
        var url = candidates[i];
        fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status + ' for ' + url);
            return r.json();
          })
          .then(function (product) {
            quickAddCache[key] = product;
            if (productUrl && !product.url) product.url = productUrl;
            renderProduct(product, opts);
          })
          .catch(function (err) {
            tryNext(i + 1, err);
          });
      }

      tryNext(0, null);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (btn) {
        e.preventDefault();
        lastTrigger = btn;
        var handle = btn.dataset.productHandle;
        var purl = btn.dataset.productUrl || '';
        body.innerHTML = '<div class="quick-add-popup-loading" data-quick-add-loading><span class="quick-add-spinner"></span></div>';
        open();

        var renderOpts = { variantStyle: btn.dataset.variantStyle || 'auto' };

        // Prefer embedded JSON on the same card (fast, works behind storefront password).
        var card = btn.closest('.product-card') || btn.parentElement;
        var inline = card ? card.querySelector('[data-quick-add-data]') : null;
        if (inline && inline.textContent.trim()) {
          try {
            var product = JSON.parse(inline.textContent);
            if (purl && !product.url) product.url = purl;
            renderProduct(product, renderOpts);
            return;
          } catch (err) {
            console.warn('[quick-add] inline JSON parse failed, falling back to fetch', err);
          }
        }
        if (handle || purl) loadProduct(handle, purl, renderOpts);
        return;
      }
      if (e.target.closest('[data-quick-add-close]')) { close(); return; }
      if (e.target === overlay) { close(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    // Close popup after a successful add originating from the popup form.
    document.addEventListener('cart:added', function (e) {
      var form = e.detail && e.detail.form;
      if (form && form.matches('[data-qa-form]') && popup.classList.contains('is-open')) {
        close();
      }
    });
  }

  // ==========================================================================
  // Init
  // ==========================================================================
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    initReveal();
    initCart();
    initPredictiveSearch();
    initDrawer();
    initSlideshow();
    initAnnouncement();
    initWishlist();
    initHeaderScroll();
    initStickyATC();
    initRelatedProducts();
    initCollectionFilters();
    initVideo();
    initVariantPickers();
    initProductGallery();
    initQuantityStepper();
    initCartPage();
    initTestimonialsSlider();
    initCountdown();
    initProductTabs();
    initBuyNow();
    initDescriptionCollapse();
    initNewsletterPopup();
    initProductCarousel();
    initQuickAddPopup();
    initLocaleForms();
  });
})();
